import { Map } from "immutable"

import {
    KNOWLEDGE_DATA_LIST_REQUEST as LIST_REQUEST,
    KNOWLEDGE_DATA_LIST_RESPONSE as LIST_RESPONSE,
    KNOWLEDGE_DATA_LIST_CACHED_RESPONSE as LIST_CACHED_RESPONSE,
    KNOWLEDGE_DATA_LIST_ERROR_RESPONSE as LIST_ERROR_RESPONSE
} from "../../actions/action-types"
import buildPagingReducer from "./build-paging-reducer"
import { serialiseSearchCriteria } from "./paging-reducer-utils"

const defaultSearchCriteria = Map({
    title: ""
})

const defaultState = {
    [serialiseSearchCriteria(defaultSearchCriteria)]: {
        searchCriteria: defaultSearchCriteria
    }
}

export default buildPagingReducer(
    {
        LIST_REQUEST,
        LIST_RESPONSE,
        LIST_CACHED_RESPONSE,
        LIST_ERROR_RESPONSE
    },
    defaultSearchCriteria,
    defaultState
)
